"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.evaluatePageConditions = undefined;

var _fuzzyurl = require("fuzzyurl");

var _fuzzyurl2 = _interopRequireDefault(_fuzzyurl);

var _constants = require("../conditions/constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var evaluate = function evaluate(operator, value, test) {
  switch (operator) {
    case _constants.propertyOperators.STARTS_WITH:
      return value.startsWith(test);
    case _constants.propertyOperators.NOT_STARTS_WITH:
      return !evaluate(_constants.propertyOperators.STARTS_WITH, value, test);
    case _constants.propertyOperators.ENDS_WITH:
      return value.endsWith(test);
    case _constants.propertyOperators.NOT_ENDS_WITH:
      return !evaluate(_constants.propertyOperators.ENDS_WITH, value, test);
    case _constants.propertyOperators.CONTAINS:
      return value.includes(test);
    case _constants.propertyOperators.NOT_CONTAINS:
      return !evaluate(_constants.propertyOperators.CONTAINS, value, test);
    case _constants.propertyOperators.EQUALS:
      return value === test;
    case _constants.propertyOperators.NOT_EQUALS:
      return !evaluate(_constants.propertyOperators.EQUALS, value, test);
    case _constants.propertyOperators.REGEX:
      try {
        return !!value.match(new RegExp(test));
      } catch (e) {
        return false;
      }
  }
};

var evaluatePageConditions = exports.evaluatePageConditions = function evaluatePageConditions(clause, profileValue) {
  var urlObject = _fuzzyurl2.default.fromString(profileValue);
  var domain = urlObject.hostname;

  if (clause.and) {
    return clause.and.map(function (clause) {
      return evaluatePageConditions(clause, profileValue);
    }).every(function (it) {
      return it;
    });
  } else if (clause.or) {
    return clause.or.map(function (clause) {
      return evaluatePageConditions(clause, profileValue);
    }).some(function (it) {
      return it;
    });
  } else {
    switch (Object.keys(clause)[0]) {
      case "url":
        var queryString = urlObject.query ? "?" + urlObject.query : "";
        var fragmentString = urlObject.fragment ? "#" + urlObject.fragment : "";
        var pathString = urlObject.path ? urlObject.path : "";
        var pathWithoutTrailingSlash = pathString.replace(/\/$/, "");
        var queryAndFragment = "" + queryString + fragmentString;

        var urlWithoutTrailingSlash = ("" + pathWithoutTrailingSlash + queryAndFragment).toLowerCase();
        var urlWithTrailingSlash = (pathWithoutTrailingSlash + "/" + queryAndFragment).toLowerCase();

        var lowerCaseClause = clause.url.value.toLowerCase();

        var negated = _constants.negatedOperators.some(function (operator) {
          return clause.url.operator === operator;
        });

        if (negated) {
          return evaluate(clause.url.operator, urlWithoutTrailingSlash, lowerCaseClause) && evaluate(clause.url.operator, urlWithTrailingSlash, lowerCaseClause);
        } else {
          return evaluate(clause.url.operator, urlWithoutTrailingSlash, lowerCaseClause) || evaluate(clause.url.operator, urlWithTrailingSlash, lowerCaseClause);
        }
      case "domains":
        var clauseDomain = clause.domains.value.toLowerCase();
        var domainMask = _fuzzyurl2.default.mask({ hostname: clauseDomain });
        var lowerCaseDomain = domain.toLowerCase();

        return evaluate(clause.domains.operator, lowerCaseDomain, clauseDomain) || _fuzzyurl2.default.matches(domainMask, lowerCaseDomain);
      case "segments":
        return true;

      default:
        return true;
    }
  }
};